// Slick gallery
import 'slick-carousel';

// Color Picker
import '../ext/colorpicker/jquery.colorpicker';

// Number Slider
import 'bootstrap-touchspin';


// Filter Box
var frmFilter = $("#frmFilter");
frmFilter.find("select").change(function(){
  frmFilter.submit();
});

// Read all
/*
var $read = $('#readall');
if($read.length>0) {
  $read.find('.more a').click(function(){
    $read.find('.desc').css('max-height','100%');
    $read.find('.mask').hide();

    $(this).parent().hide();
    return false;
  });

  $(window).on('load resize', function(){
    if($read.height()<200) $read.find('.more a').click();
  });
}
*/

// Product Detail
if($('#product').length>0) {
  var $forms = $('#form label'),
      $sku = $('#sku'),
      $color = $('#color'),
      $cpickr = $('#colorpickr select'),
      $sizes = $('#size label'),
      $oprice = $('#oprice'),
      $price = $('#price');

  var pdata = {},
      json = $('#data').val();
  if(json!='') pdata = $.parseJSON(json);
  //console.log(pdata);

  var $slider = $('.gallery, .gallery-nav');
  $slider.on('init breakpoint', function(event, slick){
    var height = slick.$slider.height();
    console.log('Gallery: height='+height);
  
    var $slides = slick.$slider.find('.slick-slide');
    if(height>600) height = 600;
    $slides.height(height);
    $slides.find('.image')
      .css('display', 'flex')
      .outerHeight(height);
    console.log('Image: height=' + height);
    
    var noimg = $slides.find('.image').length
    if (noimg > 1) $('.gallery-nav').show();
    else $('.gallery-nav').hide();
  });
  
  $('.gallery').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.gallery-nav'
  });
  $('.gallery-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.gallery',
    dots: false,
    centerMode: true,
    centerPadding: '5px',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          arrows: false,
          centerPadding: '50px'
        }
      }
    ]
  });
  
  
  $("input[name='no']").TouchSpin({
    min: 1,
    max: 1000,
    step: 1,
    buttondown_class: "btn btn-link",
    buttonup_class: "btn btn-link"
  });
  
  
  // So luong san pham
  function NumOfProduct(form, color, size){
    var qty = 0;
    $.each(pdata.view, function(i,v){
      if(v.form==form && v.color==color) qty += v.qty[size];
    });
    
    return qty;
  }

  // Tim san pham
  function FindProduct(id){
    var prod = null;
    $.each(pdata.view, function(i,v){
      if(v.id==id) {
        prod = v;
        return false;
      }
    });
    
    return prod;
  }

  // Cap nhat hinh anh
  function ChangeSlider(sku){
    console.log('Change Slide Images ['+sku+']');

    $slider.each(function(){
      var $slide = $(this);
      $slide.slick('slickUnfilter');

      $slide.find('.slick-slide').each(function(){
        var $item = $(this);
        $item.removeClass('shown');

        var img = $item.find('img'),
            maso = img.attr('sku');
        if(maso=='' || maso==sku) $item.addClass('shown');
      });

      $slide.slick('slickFilter', '.shown');
    });

    var noimg = $('.gallery-nav').find('.shown').length
    if(noimg>1) $('.gallery-nav').show();
    else $('.gallery-nav').hide();

    /*
    var top = $('#product').offset().top - 70;
    $('body,html').animate({scrollTop:top}, 500);
    */
  }

  // Cap nhat kich thuoc
  function ChangeSize(form, color){
    console.log('Change List Sizes ['+form+', '+color+']');

    $sizes.each(function(){
      var label = $(this),
          radio = label.find('input'),
          size = radio.val(),
          show = false;
      
      if(label.data('form')==form){
        var qty = NumOfProduct(form,color,size);
        if(qty>0) show = true;
      }
      
      if(show) label.show();
      else {
        label.hide();
        label.removeClass('active');
        radio.prop('checked',false);
      }
    });

    var label = $sizes.parent().find('label:visible:first'),
        radio = label.find('input');
    radio.prop('checked',true);
    label.click();
  }


  // Form tabs
  $forms.click(function(){
    var label = $(this),
        form = label.find('input').val();
    $forms.removeClass('active');
    label.addClass('active');
    console.log('Change Form: ', label.text().trim());

    // Cap nhat mau sac
    $color.val(0);
    $cpickr.colorpicker('destroy');
    $cpickr.html('');

    $.each(pdata.color, function(i,colr){
      $.each(pdata.view, function(j,view){
        if(view.form!=form) return true;
        if(view.color!=colr.id) return true;
        $cpickr.append('<option data-color="'+colr.code+'" data-id="'+colr.id+'" value="'+view.id+'">'+colr.name+'</option>');
      });
    });
    var opt = $cpickr.find('option:first');
    opt.prop('selected',true);
    $cpickr
      .colorpicker()
      .change();
  });
  
  // Color picker
  $cpickr.change(function() {
    var opt = $cpickr.find('option:selected'),
        color = opt.data('id');
    console.log('Change Color:', opt.text().trim());

    // Cap nhat mau sac
    $color.val(color);
    
    // Doi hinh san pham
    var prod = FindProduct($cpickr.val());
    ChangeSlider(prod.sku);
    
    // Cap nhat lai size
    var form = $forms.find('input:checked').val();
    ChangeSize(form, color);
  });

  // Size select
  $sizes.click(function(){
    var label = $(this);
    $sizes.removeClass('active');
    label.addClass('active');
    console.log('Change Size:', label.text().trim());

    // Cap nhat ma san pham, gia
    var prod = FindProduct($cpickr.val());
    $sku.html(prod.sku);
    
    if(prod.giagoc>prod.giaban){
      $oprice.show();
      $oprice.find('span').html(prod.giagoc);
    }
    else {
      $oprice.hide();
      $oprice.find('span').html('');
    }
    $price.html(prod.giaban);
  });


  // Tu dong chon truoc
  var label = $forms.parent().find('label:first'),
      radio = label.find('input');
  radio.prop('checked',true);
  label.click();
}


// WEBPACK FOOTER //
// ./src/product.js